import * as React from "react"

const DefaultAway = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={218.617}
    height={195.738}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 2951 2642"
    {...props}
  >
    <defs>
      <style>{".fil1{fill:#a79ecd}"}</style>
    </defs>
    <g id="Livello_x0020_1">
      <path
        d="M1723 130c-62 32-159 63-295 58-124-4-215-35-274-63 48 115 152 186 285 186 127 0 234-73 285-181zm710 964 45 46 362-361-48-49-355-360c-13-12-36-34-61-56-31 68-136 326-104 617l161 163zM163 724l-54 55 354 362 54-56 162-168c17-276-86-516-122-591-52 49-91 92-92 93L162 726zM1868 97c-7-1-40-7-47-8-43 177-196 302-383 302-188 0-334-119-379-298-7 1-40 9-47 10-45 10-79 21-109 30l-20 6c-56 17-179 70-226 103-27 19-54 42-79 64 37 76 166 367 121 690h-1v1520c108 13 427 48 747 48 420 0 710-34 800-47V926c-31-305 84-573 110-630-26-23-51-45-63-53-41-29-128-73-175-89-39-14-140-38-250-58z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        className="fil1"
        d="m2475 1251-158-157zM1759 7l7-7-7 7zM1151 34c2 1 3 2 5 3-2-1-3-2-5-3z"
      />
      <path
        d="M1869 95c-7-1-40-7-47-8-43 177-196 302-383 302-188 0-334-119-379-298-7 1-40 9-47 10-45 10-79 21-109 30l-20 6c-56 17-179 70-226 103-27 19-54 42-79 64 37 76 166 367 121 690h-1v1520c108 13 427 48 747 48 420 0 710-34 800-47V924c-31-305 84-573 110-630-26-23-51-45-63-53-41-29-128-73-175-89-39-14-140-38-250-58zm115 1720h-221l-88-231h-406l-84 231H968l393-1013h217l406 1013zm-375-402-141-375-137 375h278zm825-320 45 46 362-361-48-49-355-360c-13-12-36-34-61-56-31 68-136 326-104 617l161 163zM164 723l-54 55 354 362 54-56 162-168c17-276-86-516-122-591-52 49-91 92-92 93L163 725zm1560-593c-62 32-159 63-295 58-124-4-215-35-274-63 48 115 152 186 285 186 127 0 234-73 285-181zM1048 14v-2l18-1c8-1 17-3 26-4l18-3 4 4 12-1c0 4 1 8 1 12 20 15 121 84 304 91 222 8 317-90 321-94l1-1V8h6l6-7 20 2c149 20 304 57 359 76 54 19 147 66 194 99 35 24 142 124 154 135l459 466-476 472-157-157v1489l-31 6c-13 2-311 53-835 53-393 0-774-53-778-53l-29-5V1087l-168 163L1 777l410-416c3-3 101-114 202-186 62-44 196-99 248-114l20-6c42-13 92-29 167-43z"
        style={{
          fill: "#252422",
          fillRule: "nonzero",
        }}
      />
    </g>
  </svg>
);

export default DefaultAway;
